import { render } from "./TvmMyVehicle.vue?vue&type=template&id=2fde0440&scoped=true"
import script from "./TvmMyVehicle.vue?vue&type=script&lang=js"
export * from "./TvmMyVehicle.vue?vue&type=script&lang=js"

import "./TvmMyVehicle.vue?vue&type=style&index=0&id=2fde0440&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fde0440"]])

export default __exports__